<div mat-dialog-content>
	<h1 class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style="text-align: center !important;font-weight: bold;">{{labelResponse}}</h1>
	<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row" [formGroup]="FormPallets">
	
		<mat-form-field appearance="fill" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 InputSty">
			<mat-label>Select New Customer</mat-label>
			<mat-select formControlName="customer"	>
			  <mat-option
				*ngFor="let item of PlaceOrderCustomer"
				[value]="item.key"
				>{{ item.value }}</mat-option
			  >
			</mat-select>
		  </mat-form-field>
		  <mat-form-field  appearance="fill"
		  class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 InputSty">
			<mat-label>Search Location</mat-label>
			<input matInput (keyup)="applyFilterLocation($event)" #input />
		   
			<mat-hint>Filter Location</mat-hint>
		  </mat-form-field>
		  <mat-form-field appearance="fill" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 InputSty">
			<mat-label>New Location</mat-label>
			<mat-select formControlName="location" #locations>
			  <mat-option
				*ngFor="let item of ArrayLocations"
				[value]="item.id"
				>Location: {{ item.location }} - Description: {{ item.locationDescription }}</mat-option
			  >
			</mat-select>
		  </mat-form-field>
		  <button   mat-raised-button
		  color="danger" (click)="OnSaveUpdatePalletCustomers()" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12  InputSty" *ngIf="viewBtn">Update</button>

	</div>
  
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
</div>
